// export const Skeleton = ({ className = "" }) => (
//   <div
//     className={`animate-pulse rounded-md bg-skeleton-end dark:bg-skeleton-start ${className}`}
//   />
// );

import Skeleton from "../../Common/Skeleton";

const BeneficiaryItemSkeleton = () => (
  <div className="flex items-center gap-3 rounded-xl border border-divider p-4">
    <Skeleton className="h-12 w-12 !rounded-full" />

    <div className="flex-1 space-y-2">
      <Skeleton className="h-4 w-36" />
      <Skeleton className="h-3 w-24" />
    </div>

    <Skeleton className="h-6 w-6 rounded-full" />
  </div>
);

const BeneficiaryDetailsSkeleton = () => (
  <div className="flex flex-1 flex-col gap-6">
    <Skeleton className="h-8 w-56 rounded-md" />

    <div className="flex items-center gap-3 rounded-xl py-4">
        <Skeleton className="h-12 w-12 !rounded-full" />
        <Skeleton className="h-4 w-36 rounded-sm" />
    </div>

    <div className="space-y-5">
        <div className="rounded-xl border border-divider p-4 space-y-3">
            {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="space-y-2">
                    {/* <Skeleton className="h-3 w-28" /> */}
                    <Skeleton className="h-11 w-full rounded-lg" />
                </div>
            ))}
        </div>
    </div>

    <Skeleton className="h-12 w-full rounded-lg" />
  </div>
);

const CryptoBeneficiariesSkeleton = () => {
  return (
    <>
      {/* Desktop */}
      <div className="hidden lg:flex lg:flex-row lg:gap-9">
        <div className="w-[500px] shrink-0">
          <Skeleton className="h-8 w-56 mb-6 rounded-md" />
          <Skeleton className="mb-2 h-16 w-full rounded-lg" />

          <Skeleton className="h-10 mt-3 mb-6 rounded-lg" />
          <div className="space-y-1">
            {Array.from({ length: 6 }).map((_, index) => (
              <BeneficiaryItemSkeleton key={index} />
            ))}
          </div>
        </div>

        <div className="w-px bg-divider" />

        <BeneficiaryDetailsSkeleton />
      </div>

      {/* Mobile */}
      <div className="space-y-4 lg:hidden">
        <Skeleton className="h-11 w-full rounded-lg" />

        {Array.from({ length: 6 }).map((_, index) => (
          <BeneficiaryItemSkeleton key={index} />
        ))}
      </div>
    </>
  );
};


export const BeneficiarySkeleton = () => (
  <div className="mt-2 px-4 py-3 rounded-xl border border-divider">
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-3">
        <div className="relative shrink-0">
          <Skeleton className="h-10 w-10 rounded-full" />
          <Skeleton className="absolute -bottom-1 -right-1 h-5 w-5 rounded-full border-2 border-background-surface" />
        </div>

        <div className="space-y-2">
          <Skeleton className="h-4 w-32 rounded" />
          <Skeleton className="h-3 w-20 rounded" />
        </div>
      </div>

      <Skeleton className="h-3 w-10 rounded" />
    </div>
  </div>
);

export default CryptoBeneficiariesSkeleton;